import { langInAppDictionnary } from "@/modules/i18n/i18n.consts";
import { LangObject, LocalesDict } from "@/modules/i18n/types/i18n.types";
import React from "react";

type CurrentLangContext = {
  appCurrentLang: LangObject;
  setAppCurrentLang: (value: LangObject) => void;
};

export default React.createContext<CurrentLangContext>({
  appCurrentLang: langInAppDictionnary[LocalesDict.ENGLISH_US],
  setAppCurrentLang: (value) => {},
});
